module.exports = {
  ink: {
    lighter: "#72777A",
    light: "#6C7072",
    DEFAULT: "#404446",
    dark: "#303437",
    darker: "#202325",
    darkest: "#090A0A",
  },
  sky: {
    lightest: "#F7F9FA",
    lighter: "#EDEFF0",
    light: "#E3E5E5",
    DEFAULT: "#CDCFD0",
    white: "#FFFFFF",
    dark: "#979C9E",
  },
  primary: {
    lightest: "#D7EBFF",
    lighter: "#6AA6EB",
    light: "#1D60AD",
    DEFAULT: "#003067",
    dark: "#00234B",
  },
  secondary: {
    lightest: "#ECDDBF",
    lighter: "#D9BE86",
    light: "#C6AA6E",
    DEFAULT: "#B49759",
    dark: "#A08344",
  },
  red: {
    lightest: "#FFE5E5",
    lighter: "#FF9898",
    light: "#FF6D6D",
    DEFAULT: "#FF5247",
    dark: "#D3180C",
    darkest: "#B3261E",
  },
  green: {
    lightest: "#ECFCE5",
    lighter: "#7DDE86",
    light: "#4CD471",
    DEFAULT: "#23C16B",
    dark: "#198155",
  },
  yellow: {
    lightest: "#FFEFD7",
    lighter: "#FFD188",
    light: "#FFC462",
    DEFAULT: "#FFB323",
    dark: "#A05E03",
  },
  blue: {
    lightest: "#C9F0FF",
    lighter: "#9BDCFD",
    light: "#6EC2FB",
    DEFAULT: "#48A7F8",
    dark: "#0065D0",
  },
  facebook: {
    DEFAULT: "#0078FF",
    dark: "#0067DB",
  },
  twitter: {
    DEFAULT: "#1DA1F2",
    dark: "#0C90E1",
  },
};
